import { render, staticRenderFns } from "./AnagraficaModalComponent.vue?vue&type=template&id=52fc9cf7"
import script from "./AnagraficaModalComponent.vue?vue&type=script&lang=js"
export * from "./AnagraficaModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports